'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getLabelForProvider;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DIGITAL_PROVIDERS = _constantsAnalytics2.default.DIGITAL_PROVIDERS;
function getLabelForProvider(provider) {
  return provider === 'ILS' ? undefined : DIGITAL_PROVIDERS[provider];
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/getLabelForProvider.js
// module id = 458
// module chunks = 0 2 4 5 6 8 9 10 11